import { useContext, useEffect, useRef, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import { useParams } from "react-router-dom";
import { toast } from "../../services/toastService";
import { bookingService } from "../../services/bookingService";
import Loading from "../../components/common/Loading";
import BackButton from "../../components/common/BackButton";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const BookingDetails = () => {
  const { t,lang } = useContext(LocaleContext);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const printRef = useRef(null);
  useEffect(() => {
    getDeatil();
  },[]);

  const handleDownloadPdf = async () => {
    if (!printRef.current) return;
    try {
      setDownloading(true);
      const canvas = await html2canvas(printRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: "a4",
      });
      const margin = 10;
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const contentWidth = pageWidth - margin * 2;
      const contentHeight = pageHeight - margin * 2;

      const ratio = canvas.width / contentWidth;
      const sliceHeightPx = Math.floor(contentHeight * ratio);

      let renderedHeight = 0;
      let pageIndex = 0;

      while (renderedHeight < canvas.height) {
        const sliceHeight = Math.min(sliceHeightPx, canvas.height - renderedHeight);
        const sliceCanvas = document.createElement("canvas");
        sliceCanvas.width = canvas.width;
        sliceCanvas.height = sliceHeight;
        const sliceCtx = sliceCanvas.getContext("2d");
        sliceCtx.fillStyle = "#ffffff";
        sliceCtx.fillRect(0, 0, sliceCanvas.width, sliceCanvas.height);
        sliceCtx.drawImage(
          canvas,
          0,
          renderedHeight,
          canvas.width,
          sliceHeight,
          0,
          0,
          canvas.width,
          sliceHeight
        );

        if (pageIndex > 0) pdf.addPage();
        pdf.addImage(
          sliceCanvas.toDataURL("image/png"),
          "PNG",
          margin,
          margin,
          contentWidth,
          sliceHeight / ratio
        );

        renderedHeight += sliceHeight;
        pageIndex += 1;
      }

      pdf.save(`${t("bookingNumber")}-${data?.code ?? id}.pdf`);
    } catch (error) {
      toast.error(t("anErrorOccurredPleaseTryAgainLater"));
      console.log(error);
    } finally {
      setDownloading(false);
    }
  };

  const getDeatil = async () => {
    try {
      setLoading(true);
      const result = await bookingService.getDetail(id);
      if(!result.isSuccess)
      {
        toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        console.log(result);
        return;
      }
      setData(result.value);
      console.log(result);
    } catch (error) {
      toast.error(t("anErrorOccurredPleaseTryAgainLater"));
      console.log(error);
    }
    finally{
      setLoading(false);
    }
  };
  if(loading) return <Loading />

  return (
    <section className="section-booking-details">
      <div className="default-heading no-print">{t("bookings")}</div>
      <div className="my-card">
        <div className="my-card-header d-flex justify-content-between align-items-center no-print">
          {t("bookingDetails")}
          <div className="d-flex gap-2"  style={{fontSize:"13px"}}>
            <button
              type="button"
              className="btn-default"
              onClick={handleDownloadPdf}
              disabled={downloading}
            >
              <i className="fas fa-file-pdf"></i>{" "}
              {downloading ? t("loading") : t("downloadPdf")}
            </button>
            <BackButton />
          </div>
        </div>
        <div ref={printRef}>
        <div className="my-card-dark">
          <div className="row">
            <div className="col-12 col-md-3 ">
              <div className="my-heading border-right-white border-bottom-white flex-center">
                {t("tripsApp")}
              </div>
            </div>
            <div className="col-12 col-md-9">
              <div className="my-dark-card-items">
                <div className="my-dark-card-item">
                  <strong>{t("bookingNumber")}</strong>
                  <span>{data?.code}</span>
                </div>
                <div className="my-dark-card-item">
                  <strong>{t("bookingDate")}</strong>
                  <span>{data?.bookingDate?.toDate()}</span>
                </div>
                <div className="my-dark-card-item">
                  <strong>{t("status")}</strong>
                  <span>{t(data?.status)}</span>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="my-heading border-right-white  flex-center">
                {t("bookingDetails")}
              </div>
            </div>
            <div className="col-12 col-md-9">
              <div className="my-dark-card-items border-0">
                <div className="my-dark-card-item">
                  <strong>{t("noOfPeople")}</strong>
                  <span>
                    {data?.noOfPeople} {t("people")}
                  </span>
                </div>
                <div className="my-dark-card-item">
                  <strong>
                    {t("noOf")} {t(data?.unit)}
                  </strong>
                  <span>
                    {data?.unitNumber} {t(data?.unit)}
                  </span>
                </div>
                <div className="my-dark-card-item">
                  <strong>{t("startTime")}</strong>
                  <span>{data?.startTime?.toTime(lang)}</span>
                </div>
                <div className="my-dark-card-item">
                  <strong>{t("endTime")}</strong>
                  <span>
                    {data?.startTime?.toTime(lang, data?.unitNumber ?? 0)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="my-card-dark mt-3">
          <div className="my-card-header">{t("costDetails")}</div>
          <div className="row">
            <div className="col-12 col-md-3">
              <div className="box-3d">
                <div className="box-3d-heading">{t("packageCost")}</div>
                <div className="box-3d-item">
                  <bold>{t("noCommission")}</bold>
                  <span>
                    {data?.noCommission} {t("riyal")}
                  </span>
                </div>
                <div className="box-3d-item">
                  <bold>{t("withCommission")}</bold>
                  <span>
                    {data?.totalCost} {t("riyal")}
                  </span>
                </div>
                <div className="box-3d-item">
                  <bold>{t("serviceFeesPackage")} :</bold>
                  <span>
                    {data?.appCommission} {t("riyal")}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="box-3d">
                <div className="box-3d-heading">{t("addOnsCost")}</div>
                <div className="box-3d-item">
                  <bold>{t("total")}</bold>
                  <span>
                    {data?.addonCost} {t("riyal")}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="box-3d">
                <div className="box-3d-heading">{t("appCommission")}</div>
                <div className="box-3d-item justify-content-center">
                  <span>
                    {data?.appCommission} {t("riyal")}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="box-3d">
                <div className="box-3d-heading">{t("providerCommission")}</div>
                <div className="box-3d-item justify-content-center">
                  {/* no commission means provider cost */}
                  <span>
                    {data?.noCommission} {t("riyal")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="my-card-dark mt-3">
          <div className="my-card-header d-flex justify-content-center m-0">
            {t("totalTripCost")} {data?.totalCost} {t("riyal")}
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12 col-md-6">
            <div className="my-card-dark mt-3">
              <div className="my-card-header">{t("clientInformation")}</div>
              <div className="bordered-item d-none">
                <b>{t("id")}</b> : {data?.customer?.id}
              </div>
              <div className="bordered-item">
                <b>{t("name")}</b> : {data?.customer?.name}
              </div>
              <div className="bordered-item">
                {t("userName")} : {data?.customer?.userName}
              </div>
              <div className="bordered-item">
                {t("email")} : {data?.customer?.email}
              </div>
              <div className="bordered-item">
                {t("city")} :  {data?.customer?.city[lang]}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="my-card-dark mt-3">
              <div className="my-card-header">{t("providerInformation")}</div>
              <div className="bordered-item d-none">
                <b>{t("id")}</b> :  {data?.provider?.id}
              </div>
              <div className="bordered-item">
                <b>{t("name")}</b> : {data?.provider?.name}
              </div>
              <div className="bordered-item">
                {t("userName")} : {data?.provider?.userName}
              </div>
              <div className="bordered-item">
                {t("email")} : {data?.provider?.email}
              </div>
              <div className="bordered-item">
                {t("city")} :  {data?.provider?.city[lang]}
              </div>
            </div>
          </div>
        </div>
        <div className="my-card-dark mt-3">
          <div className="row">
            <div className="col-12 col-md-3">
              <div className="my-heading border-right-white flex-center">
                {t("bankInformation")}
              </div>
            </div>
            <div className="col-12 col-md-9 h-100">
              <div className="my-dark-card-items">
                <div className="my-dark-card-item">
                  <strong>{t("bankName")}</strong>
                  <span>{data?.provider?.bankName[lang]}</span>
                </div>
                <div className="my-dark-card-item">
                  <strong>{t("ibanNo")}</strong>
                  <span>{data?.provider?.iban}</span>
                </div>
              </div>
              <div className="my-dark-card-items border-0">
                <div className="my-dark-card-item">
                  <strong>{t("total")}</strong>
                  <span>
                    {data?.provider?.balance ?? 0} {t("riyal")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="my-card-dark mt-3">
          <div className="row">
            <div className="col-12 col-md-3">
              <div className="my-heading border-right-white flex-center">
                {t("tripInformation")}
              </div>
            </div>
            <div className="col-12 col-md-9 h-100">
              <div className="my-dark-card-items">
                <div className="my-dark-card-item">
                  <strong>{t("name")}</strong>
                  <span>{data?.trip?.name[lang]}</span>
                </div>
                <div className="my-dark-card-item">
                  <strong>{t("maxNoOfPeople")}</strong>
                  <span>{data?.trip?.maxPersons}</span>
                </div>
              </div>
              <div className="my-dark-card-items border-0">
                <div className="my-dark-card-item">
                  <strong>{t("total")}</strong>
                  <span>
                    {data?.provider?.balance ?? 0} {t("riyal")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {data?.addons && data?.addons?.length > 0 && (
          <div className="my-card-dark mt-3">
            <div className="row">
              <div className="col-12 col-md-3">
                <div className="my-heading border-right-white flex-center">
                  {t("selectedAddOns")}
                </div>
              </div>
              <div className="col-12 col-md-9 h-100">
                <div className="my-dark-card-items">
                  {data.addons.map((addon,index) => (
                    <div className="my-dark-card-item" key={index}>
                      <strong>{addon.name[lang]} ({addon?.quantity})</strong>
                      <span>
                        {t("price")} : {addon.price} {t("riyal")} 
                      </span>
                    </div>
                  ))}
                </div>
                <div
                  className="my-dark-card-items border-0"
                  style={{ height: "68.19px" }}
                >
                   <div className="my-dark-card-item">
                      <strong>{t("total")}</strong>
                      <span>
                       {data?.addonCost}{" "}
                        {t("riyal")}
                      </span>
                    </div>
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
      </div>
    </section>
  );
};

export default BookingDetails;
